<nav>
  @if (totalPagesCount() > 1) {
    <ul class="pagination mt-4 justify-content-center">
      <li class="page-item" [class.disabled]="currentPage() === 1">
        <a
          class="page-link"
          href="#"
          aria-label="vorherige"
          (click)="$event.preventDefault(); setPage(currentPage() - 1)"
          (keydown.enter)="$event.preventDefault(); setPage(currentPage() - 1)"
        >
          <span aria-hidden="true">&laquo;</span>
          <span class="visually-hidden">vorherige</span>
        </a>
      </li>
      @for (pageNumber of pageNumbers(); track pageNumber) {
        @if (
          pageNumber === 1 ||
          pageNumber === totalPagesCount() ||
          (pageNumber > currentPage() - (pageRangeDisplay + 1) && pageNumber < currentPage() + (pageRangeDisplay + 1))
        ) {
          <li class="page-item" [class.active]="pageNumber === currentPage()">
            <a
              class="page-link"
              href="#"
              (click)="$event.preventDefault(); setPage(pageNumber)"
              (keydown.enter)="$event.preventDefault(); setPage(pageNumber)"
              [class.disabled]="
                !(
                  pageNumber === 1 ||
                  pageNumber === totalPagesCount() ||
                  (pageNumber > currentPage() - pageRangeDisplay && pageNumber < currentPage() + pageRangeDisplay)
                )
              "
            >
              {{
                pageNumber !== 1 &&
                (pageNumber <= currentPage() - pageRangeDisplay || pageNumber >= currentPage() + pageRangeDisplay) &&
                pageNumber !== totalPagesCount()
                  ? '...'
                  : pageNumber
              }}
            </a>
          </li>
        }
      }
      <li class="page-item" [class.disabled]="currentPage() === totalPagesCount()">
        <a
          class="page-link"
          href="#"
          aria-label="nächste"
          (click)="$event.preventDefault(); setPage(currentPage() + 1)"
          (keydown.enter)="$event.preventDefault(); setPage(currentPage() + 1)"
        >
          <span aria-hidden="true">&raquo;</span>
          <span class="visually-hidden">nächste</span>
        </a>
      </li>
    </ul>
  }
</nav>
